import { render } from "./BaseLinkButton.vue?vue&type=template&id=32549357"
import script from "./BaseLinkButton.vue?vue&type=script&lang=js"
export * from "./BaseLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__